import { render, staticRenderFns } from "./Clipboard.vue?vue&type=template&id=a43dcb7e&scoped=true&"
import script from "./Clipboard.vue?vue&type=script&lang=js&"
export * from "./Clipboard.vue?vue&type=script&lang=js&"
import style0 from "./Clipboard.vue?vue&type=style&index=0&id=a43dcb7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a43dcb7e",
  null
  
)

export default component.exports